module.exports = __webpack_public_path__ + "static/media/zoom-in.4ac94902.svg";